import { PII_FIELDS } from '@globals/personalIdentifierInfo/pIISanitizeUtils'
import { Provider } from '@rollbar/react'
import { FC, ReactNode } from 'react'
import type { Configuration } from 'rollbar'
import { envConfig } from './globals/env'
import { ROLLBAR_HOST_SAFE_LIST, transformRollbarPayload } from './rollbarProviderUtils'

type RollbarProviderProps = {
  children: ReactNode
}

const ENV: string = envConfig.DEPLOY_ENVIRONMENT
const ROLLBAR_ACCESS_TOKEN: string = envConfig.ROLLBAR_SDK_ID
const APP_VERSION: string = envConfig.APP_VERSION

const rollbarConfig: Configuration = {
  accessToken: ROLLBAR_ACCESS_TOKEN,
  environment: ENV,
  captureUncaught: true,
  captureUnhandledRejections: false,
  reportLevel: 'warning',
  scrubFields: [...PII_FIELDS],
  hostSafeList: ROLLBAR_HOST_SAFE_LIST,
  // IMPORTANT needed so that default scrub fields from rollbar
  // remain scrubbed
  overwriteScrubFields: false,
  transform: transformRollbarPayload,
  payload: {
    client: {
      javascript: {
        code_version: APP_VERSION,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
}

const RollBarProvider: FC<RollbarProviderProps> = ({ children }) => (
  <Provider config={rollbarConfig}>{children}</Provider>
)

export default RollBarProvider
